import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=681a9e78&scoped=true&lang=pug"
import script from "./CalendarView.vue?vue&type=script&lang=js"
export * from "./CalendarView.vue?vue&type=script&lang=js"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=681a9e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a9e78",
  null
  
)

export default component.exports